import { ModuleWidget, SOFTLINE_WIDGET_OUTLET_DASHBOARD } from '@softapps/core';
import { SOFTLINE_PERMISSION_TIMESTAMP } from './stempelerfassung.permissions';

// Widget registrations — loaded when a matching widget-outlet renders
// (federation via ./ModuleWidgets); the legacy apps keep using
// stempelerfassungWidgetProviders (same entries via provideModuleWidgets).
export function stempelerfassungWidgets(): ModuleWidget[] {
  return [
    {
      outletNames: [SOFTLINE_WIDGET_OUTLET_DASHBOARD],
      group: 'pms',
      loadComponent: () =>
        import('./widgets/work-hours/work-hours.widget').then((m) => m.WorkHoursWidget),
      permission: SOFTLINE_PERMISSION_TIMESTAMP,
    },
    {
      outletNames: [SOFTLINE_WIDGET_OUTLET_DASHBOARD],
      group: 'pms',
      loadComponent: () =>
        import('./widgets/stempelerfassung/stempelerfassung.widget').then(
          (m) => m.StempelerfassungWidget
        ),
      permission: SOFTLINE_PERMISSION_TIMESTAMP,
    },
  ];
}
